import Head from 'next/head'
import constants from 'lib/constants'

const DEFAULT_META = {
  title: 'Stores - Everlane',
  description: 'Find an Everlane location near you.',
  url: '/stores',
  image: constants.DEFAULT_IMAGE,
}

const Meta = ({ ...metadata }) => {
  const {
    title = DEFAULT_META.title,
    description = DEFAULT_META.description,
    url = DEFAULT_META.url,
    image = DEFAULT_META.image,
  } = metadata

  return (
    <Head>
      <meta property="og:url" content={`${constants.URL_BASE}${url}`} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Everlane" />
      <title>{title}</title>
      <meta property="description" name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" name="og:image" content={image} />
      <link rel="canonical" href={url} />
    </Head>
  )
}

export default Meta
